/* eslint-disable jira/react/no-style-attribute */
import React from 'react';

import { token } from '@atlaskit/tokens';

export const Clouds = () => (
	<svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 85 200">
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
		<g style={{ mixBlendMode: 'screen' }}>
			<path
				fill={token('color.background.accent.gray.subtler', '#DCDFE4')}
				d="M205.165 216c-12.255 0-22.195-9.637-22.212-21.537v-.01c-.004-11.91-9.954-21.561-22.219-21.558h-23.86c-12.265-.003-22.205-9.665-22.201-21.575v-.01c-.004-11.91-9.954-21.561-22.2191-21.558H22.1622C9.8969 129.728-.0248 120.049 0 108.14v-.297c0-11.9097 9.943-21.5644 22.2084-21.5644h5.5254c12.2654 0 22.2084-9.6547 22.2084-21.5645v-.0103c0-11.9098 9.943-21.5645 22.2083-21.5645h13.7817c12.2654 0 22.2088-9.6547 22.2088-21.5645C108.141 9.6582 118.087 0 130.36 0H373.69c6.627 0 12 5.3726 12 12v192c0 6.627-5.373 12-12 12H205.161h.004Z"
				opacity=".35"
			/>
			<path
				fill={token('color.background.accent.gray.subtlest', '#F1F2F4')}
				d="M230.473 216c-12.255 0-22.194-9.637-22.212-21.537v-.01c-.003-11.91-9.953-21.561-22.219-21.558h-23.859c-12.266-.003-22.205-9.665-22.202-21.575v-.01c-.003-11.91-9.953-21.561-22.219-21.558H47.4708c-12.2653-.024-22.187-9.703-22.1622-21.612v-.297c0-11.9097 9.943-21.5644 22.2084-21.5644h5.5254c12.2654 0 22.2084-9.6547 22.2084-21.5645v-.0103c0-11.9098 9.943-21.5645 22.2083-21.5645h13.7819c12.265 0 22.208-9.6547 22.208-21.5645C133.449 9.6582 143.396 0 155.668 0h243.331c6.627 0 12 5.3726 12 12v192c0 6.627-5.373 12-12 12H230.47h.003Z"
				opacity=".45"
			/>
		</g>
	</svg>
);
